import { render, staticRenderFns } from "./ListServico.vue?vue&type=template&id=3f1e01cc"
import script from "./ListServico.vue?vue&type=script&lang=js"
export * from "./ListServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports